
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/site/vs/gohighlevel",
      function () {
        return require("private-next-pages/site/vs/gohighlevel.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/site/vs/gohighlevel"])
      });
    }
  